var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#0061ED",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99983 5.25C10.2984 5.25 10.5971 5.36401 10.8248 5.59153L17.9911 12.758C18.447 13.2139 18.447 13.953 17.9911 14.4087C17.5354 14.8644 16.7965 14.8644 16.3405 14.4087L9.99983 8.06747L3.65886 14.4082C3.20317 14.8639 2.4641 14.8639 2.00845 14.4082C1.55236 13.9525 1.55236 13.2137 2.00845 12.7578L9.17462 5.59127C9.40247 5.36379 9.70113 5.25 9.99983 5.25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default ForwardRef;